module.exports = __webpack_public_path__ + "img/calender.5b055d6.svg";